// extracted by mini-css-extract-plugin
module.exports = {"accountInfo":"AppNav_accountInfo__3J3p9","brand":"AppNav_brand__1caE2","user":"AppNav_user__43Tc-","wrapper":"AppNav_wrapper__nmbya"};